import { observeElement } from '@uvocore-front/utils';
import Slider from '../Slider';

observeElement({
  element: '[data-top-writers-slider]',
  marginValue: 100,
  callback: () => {
    Slider('[data-top-writers-slider]', {
      type: 'loop',
      gap: '24px',
      autoWidth: true,
      focus: 'center',
      arrows: false,
      perPage: 1,
      breakpoints: {
        768: {
          perPage: 2,
        },
        1024: {
          perPage: 3,
        },
      },
    }).mount();
  },
});
